<div class="component-container container">
    <div>
        <h1 class="font-mont-regular">Congratulations!</h1>
        <h2 class="font-mont-book">You have been approved for the amount of:</h2>
        <h3 class="font-mont-regular">{{ offers.maxApproved | currency:'$ ':'code':'.0-0' }}</h3>
        <table aria-describedby="offers table">
            <thead>
                <tr>
                    <th scope="col">TERM</th>
                    <th scope="col">AMOUNT</th>
                    <th scope="col">PAYMENT</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let offer of offers.offerList">
                    <td>{{offer.term}} mos</td>
                    <td>{{ (offer.useMaxApprovedAmount ? offers.maxApproved : offers.requestAmount) |
                        currency:'$ ':'code':'.0-0'}}</td>
                    <td>{{ offer.payment | currency:'$ ':'code':'.2-2' }}</td>
                </tr>
            </tbody>
        </table>
        <div class="font-mont-book">
            <span class="font-mont-book">{{dbaName}}</span>
            will be in touch to help you select payment terms and finalize the contract.
        </div>

        <div class="form-row display-block clearfix footer-buttons-container">
            <div class="form-group col-md-3 col-xs-6">
                <button type="submit" class="btn btn-primary btn-lg col-md-12" (click)="onContinueClick();" *ngIf="!token">
                    next
                </button>
            </div>
        </div>
    </div>
    <app-comments-section></app-comments-section>
</div>